import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  IdCronogramaSGQ: number;
  tipoPesquisa: number,
  status: number,
  pesquisa: string | Date | number | null,

};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setTipoPesquisa: SetFunction<number>,
  setStatus: SetFunction<number>,
  setPesquisa: SetFunction<string | Date | number | null>,
};


export const initialFiltersValues: State = {
  IdCronogramaSGQ: 0,
  tipoPesquisa: 0,
  pesquisa: "",
  status: 0,
};

export const useCronogramaSGQFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setTipoPesquisa: (vfn) => SetFunctionImpl(set, 'tipoPesquisa', vfn),
  setStatus: (vfn) => SetFunctionImpl(set, 'status', vfn),
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set(initialFiltersValues),

}));